import { Typography as T } from "@mui/material";

/**
 * Connector access is now managed per agent (via `agent_connectors`)
 * rather than per dataset. This component is left as a stub so existing
 * routes don't 404; a follow-on can rebuild the dataset-level allowlist
 * UI against the new connector model if it's still wanted.
 */
const McpServerToggles = () => (
  <T variant="body2" color="text.secondary">
    Connector settings are no longer configurable on a dataset.
  </T>
);

export default McpServerToggles;
